import { cn } from '@/lib/utils';

type ErrorNoticeProps = {
  message?: string | null;
  title?: string;
  className?: string;
};

export function ErrorNotice({ message, title = 'Something went wrong', className }: ErrorNoticeProps) {
  if (!message) return null;

  return (
    <div
      role="alert"
      className={cn('bg-destructive/10 border-destructive/25 text-destructive rounded-md border px-3 py-2', className)}
    >
      <p className="text-sm font-medium">{title}</p>
      <p className="mt-1 text-sm">{message}</p>
    </div>
  );
}
